export const AUTOMATION_OUTCOME_COLORS: Record<string, string> = {
  updated: "green",
  would_update: "gold",
  skipped_no_documents: "default",
  skipped_status_changed: "orange",
  skipped_no_declaration: "default",
  error: "red",
};

export const AUTOMATION_OUTCOME_LABELS: Record<string, string> = {
  updated: "Updated",
  would_update: "Would update (dry run)",
  skipped_no_documents: "Waiting for UTB + TTW",
  skipped_status_changed: "Status no longer eligible",
  skipped_no_declaration: "No declaration linked",
  error: "Error",
};
